import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function SandwichesPage() {

    const heroData = [
        {
          title: "Sandwiches",
          content: "Satisfy your cravings with our freshly made sandwiches, filled with premium ingredients and bold flavors.",
          image: images.SandwichesHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Roast Beef",
        content: "Roast beef with caramelized onion, rocket leaves, and cherry tomatoes in focaccia bread or ciabatta bread",
        price: 0,
        image: [
          images.Sandwich1,
        ]
      },
      {
        name: "Burrata Caprese",
        content: "Burrata cheese, tomatoes, basil, pesto sauce, and sweet balsamic in focaccia bread or ciabatta bread",
        price: 0,
        image: [
          images.Sandwich2,
        ]
      },
      {
        name: "Grilled Chicken & Pesto",
        content: "Grilled chicken with creamy pesto sauce and cherry tomatoes in focaccia bread or ciabatta bread",
        price: 0,
        image: [
          images.Sandwich3,
        ]
      },
      {
        name: "Tuna & Spinach Melt",
        content: "Tuna mousse with spinach lettuce and bell peppers in focaccia bread or ciabatta bread",
        price: 0,
        image: [
          images.Sandwich3,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Roast Beef",
        image1: [
          images.Sandwich1,
        ],
        content1: "Roast beef with caramelized onion, rocket leaves, and cherry tomatoes in focaccia bread or ciabatta bread",
        name2: "Grilled Chicken & Pesto",
        image2: [
          images.Sandwich3,
        ],
        content2: "Grilled chicken with creamy pesto sauce and cherry tomatoes in focaccia bread or ciabatta bread"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
